import type { PublicSnapshot } from "@paddock-signal/contracts";

export interface DriverFilters {
  confidence: "all" | "high" | "medium" | "low" | "unknown";
  constructorId: string;
  favoritesOnly: boolean;
  query: string;
}

function normalized(value: string): string {
  return value.normalize("NFKC").toLocaleLowerCase("en").trim();
}

export function filteredDriverIds(
  snapshot: PublicSnapshot,
  filters: DriverFilters,
  favorites: ReadonlySet<string>,
): string[] {
  const locationByDriver = new Map(
    snapshot.locations.map((location) => [location.driverId, location]),
  );
  const constructorName = new Map(
    snapshot.standings.constructors.map((constructor) => [
      constructor.constructorId,
      constructor.name,
    ]),
  );
  const query = normalized(filters.query);

  return snapshot.drivers
    .filter((driver) => driver.active)
    .filter((driver) => {
      const location = locationByDriver.get(driver.id);
      const searchable = normalized(
        `${driver.givenName} ${driver.familyName} ${driver.acronym} ${constructorName.get(driver.constructorId) ?? driver.constructorId}`,
      );
      const confidenceMatches =
        filters.confidence === "all" ||
        (filters.confidence === "unknown"
          ? location?.status !== "estimated"
          : location?.status === "estimated" &&
            location.confidenceBand === filters.confidence);
      return (
        searchable.includes(query) &&
        (filters.constructorId === "all" ||
          driver.constructorId === filters.constructorId) &&
        (!filters.favoritesOnly || favorites.has(driver.id)) &&
        confidenceMatches
      );
    })
    .map((driver) => driver.id);
}
